module.exports = __webpack_public_path__ + "static/keyword-83738ca53403579032977348871b4120.jpg";